import { JsonUtil } from "../../../../cutil/JsonUtil";
import { Handler } from "../chain/TransformServiceHandlerChain";
import { AskBrainData } from "../../../../api/askBrainTyped/AskBrain";
import { StoryNodeDisplayType } from "../../../../storyV2/domain/StoryNodeDisplayType";
import isBlank from "@sedan-utils/is-blank";
import { CustomApiTransformError } from "../error/CustomApiTransformError";
export class AskBrainHandler extends Handler {
    async process(request) {
        const displayType = request.displayType;
        /// 只处理 upload file type
        if (displayType !== StoryNodeDisplayType.ASKBRAIN) {
            return false;
        }
        if (request.isWS) {
            if (!request.websocketAskBrain) {
                throw CustomApiTransformError.default;
            }
            request.setResult(request.websocketAskBrain);
            return true;
        }
        if (request.isStream) {
            const stream = request.stream(value => {
                let askBrainData = new AskBrainData();
                askBrainData.query = request.query;
                askBrainData.answer = value;
                const sourceReg = /(\{\"sources_data\": \{.*\}\})/g;
                const execArr = sourceReg.exec(value);
                if (execArr && !isBlank(execArr)) {
                    const sourcesDataJson = JSON.parse(execArr[1]);
                    const sourcesData = JsonUtil.toModelFromType(AskBrainData, sourcesDataJson)?.sources_data;
                    askBrainData.sources_data = sourcesData;
                    askBrainData.answer = value.replace(execArr[1], "").trim();
                }
                return JsonUtil.stringify(askBrainData) || "";
            });
            if (!stream) {
                throw CustomApiTransformError.default;
            }
            request.setResult(stream);
            return true;
        }
        else {
            const json = await request.json();
            const askBrainData = JsonUtil.toModelFromType(AskBrainData, json);
            if (!askBrainData) {
                throw CustomApiTransformError.default;
            }
            request.setResult(askBrainData);
            return true;
        }
    }
}
